import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: 'agSetColumnFilter',
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'Apellido y nombres',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("internalNumber"),
            field: 'Número interno',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: 'Fecha de contratación',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("outcomeDate"),
            field: 'Fecha de egreso',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("position"),
            field: 'Cargo',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("function"),
            field: 'Función',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'Tipo de funcionario',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'Lugar de trabajo',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: 'Obra o Faena',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("category"),
            field: 'Categoría',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("specialty"),
            field: 'Especialidad',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("sex"),
            field: 'Sexo',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("nationality"),
            field: 'Nacionalidad',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("contractType"),
            field: 'Tipo de contrato',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("management"),
            field: 'Gerencia',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("department"),
            field: 'Departamento',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: 'Sindicato',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Tipo de ingreso',
            headerName: getLocalizedString("incomeType"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Tipo de estructura o Tipo de conjunto',
            headerName: getLocalizedString("structureTypeOrSetType"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Modalidad de ingreso',
            headerName: getLocalizedString("entryMode"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessOrigen"),
            field: 'Origen',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessConcepto"),
            field: 'Concepto',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessNombreConcepto"),
            field: 'Nombre del concepto',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Periodicidad',
            headerName: getLocalizedString("periodicity"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle2',
            headerClass: 'color2',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("grossReportedValue"),
            field: 'Valor informado bruto',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle3'],
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("liquidReportedValue"),
            field: 'Valor informado líquido',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle3'],
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Horas y Minutos',
            headerName: getLocalizedString("hoursAndMinutes"),
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle3',
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessAmount"),
            field: 'Cantidad',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle3'],
            valueFormatter: createNumberFormatter(5),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessPorcentaje"),
            field: 'Porcentaje',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle3'],
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessBaseCalculo"),
            field: 'Base de cálculo',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle3'],
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color3',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'En fecha',
            headerName: getLocalizedString("onDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: 'assetsDiscountsSummaryStyle5',
            headerClass: 'color45',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Período desde',
            headerName: getLocalizedString("periodFrom"),
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle4',
            headerClass: 'color4',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Período hasta',
            headerName: getLocalizedString("periodUntil"),
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle4',
            headerClass: 'color4',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("discountDate"),
            field: 'Fecha de descuento',
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: 'assetsDiscountsSummaryStyle5',
            headerClass: 'color5',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessPeriodoReliquidacion"),
            field: 'Período de reliquidación',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle6',
            headerClass: 'color6',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessMesesReliquidar"),
            field: 'Meses a reliquidar',
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: ["currencyValue", 'assetsDiscountsSummaryStyle6'],
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
            headerClass: 'color6',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Código de referencia',
            headerName: getLocalizedString("employeesProcessCodigoReferencia"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle7',
            headerClass: 'color7',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Indicador de cálculo',
            headerName: getLocalizedString("calculationIndicator"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle8',
            headerClass: 'color8',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("thirdPartySingular"),
            field: 'Tercero',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle9',
            headerClass: 'color9',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("paymentType"),
            field: 'Tipo de pago',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle9',
            headerClass: 'color9',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("paymentMethod"),
            field: 'Forma de pago',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle9',
            headerClass: 'color9',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("bank"),
            field: 'Banco',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle9',
            headerClass: 'color9',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("bankAccount"),
            field: 'Cuenta bancaria',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle9',
            headerClass: 'color9',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: 'Centro de costo',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle10',
            headerClass: 'color10',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: 'Proyecto',
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle10',
            headerClass: 'color10',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessPeriodoImputacion"),
            field: 'Período de imputación',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle11',
            headerClass: 'color11',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Ene',
            headerName: getLocalizedString("jan"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Feb',
            headerName: getLocalizedString("feb"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Mar',
            headerName: getLocalizedString("marchShort"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Abr',
            headerName: getLocalizedString("apr"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'May',
            headerName: getLocalizedString("mayShort"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Jun',
            headerName: getLocalizedString("jun"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Jul',
            headerName: getLocalizedString("jul"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Ago',
            headerName: getLocalizedString("aug"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Sep',
            headerName: getLocalizedString("sep"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Oct',
            headerName: getLocalizedString("oct"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Nov',
            headerName: getLocalizedString("nov"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Dic',
            headerName: getLocalizedString("dic"),
            filter: 'agSetColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle12',
            headerClass: 'color12',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Serie',
            headerName: getLocalizedString("series"),
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle13',
            headerClass: 'color13',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("employeesProcessNumeroComprobante"),
            field: 'Número de comprobante',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle13',
            headerClass: 'color13',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Usuario de ingreso',
            headerName: getLocalizedString("inputUser"),
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle14',
            headerClass: 'color14',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            field: 'Fecha de ingreso o modificación',
            headerName: getLocalizedString("entryOrModificationDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: 'assetsDiscountsSummaryStyle14',
            headerClass: 'color14',
        }
    },
    {
        pages: [paths.assetsDiscountsSummary],
        config: {
            headerName: getLocalizedString("comments"),
            field: 'Comentarios',
            filter: 'agTextColumnFilter',
            cellClass: 'assetsDiscountsSummaryStyle14',
            headerClass: 'color14',
        }
    },
]